<template>
	<div>
		<a-modal v-show='!ishand' id='handitemjiaban' width='36rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="width: 34rem;">
					加班申請
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div  style="width: 34rem;" class='body_lis'>
				<!--  v-if='false' -->
				<div style="margin: 0 auto;padding-top: 1.5rem;width: 90%;">
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<!-- <a-row>
							<a-col :span='14'>
								<a-col :span='7' class='titName' v-html='"員工姓名&nbsp;&nbsp;:"'></a-col>
								<a-col :span='17' class='comname'>{{formview.realname}}
									<img v-if='formview.sex == 1' :src="require('@/image/lea/man.png')" alt="">
									<img v-if='formview.sex == 2' :src="require('@/image/lea/woman.png')" alt="">
								</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='9' class='titName' v-html='"申請日期&nbsp;&nbsp;:"'></a-col>
								<a-col :span='15' class='comname'>{{formview.createtime}}</a-col>
							</a-col>
							<a-col :span='14'>
								<a-col :span='7' class='titName '
									v-html='"部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;門&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='17' class='comname'>{{formview.department}}</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='9' class='titName '
									v-html='"職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='15' class='comname'>{{formview.job}}</a-col>
							</a-col>
						</a-row> -->
						<rl @child='handff' :stas='0' :fdate='form.jbdate'></rl>
						<a-form-model-item label="">
							<!-- position: relative;left: 6.5rem;top: .5rem; -->
							<div style="margin-top: .5rem;">
								<a-radio-group v-model="form.jbtype">
									<a-radio :value="ind+1" v-for='(item,ind) in yeararr' :key='ind+"vvvv"'
										:style='{margin:ind +1 == yeararr.length?"0 0 0 7rem":""}'
										:class='item.cla?"myauto":""'>
										{{item.text}}
									</a-radio>
								</a-radio-group>
							</div>
						</a-form-model-item>
						<div>
							<a-form-model-item>
								<div slot="label" v-html='"加班時間&nbsp;&nbsp;"'
									style="display: inline-block;color: #000000;"></div>
								<div style="position: relative;left: .5rem;display: inline-block;">
									<a-input placeholder='請輸入' v-model="form.begintime1" class='warp_widths'
										:maxLength='2' @blur="inputnum('begintime1','s')" />
									<div style="display: inline-block;margin: .2rem;">:</div>
									<a-input placeholder='請輸入' v-model="form.begintime2" class='warp_widths'
										:maxLength='2' @blur="inputnum('begintime2')" />
									<div style="display: inline-block;margin: 0 .6rem;">-</div>
									<a-input placeholder='請輸入' v-model="form.endtime1" class='warp_widths'
										:maxLength='2' @blur="inputnum('endtime1','s')" />
									<div style="display: inline-block;margin: .2rem;">:</div>
									<a-input placeholder='請輸入' v-model="form.endtime2" class='warp_widths'
										:maxLength='2' @blur="inputnum('endtime2')" />
								</div>
							</a-form-model-item>
						</div>
						<div>
							<a-form-model-item>
								<div slot="label" v-html='"加班時數&nbsp;&nbsp;"'
									style="display: inline-block;color: #000000;"></div>
								<div style="position: relative;left: .5rem;display: inline-block;">{{this.form.str1}}
								</div>
							</a-form-model-item>
						</div>
						<div>
							<a-form-model-item>
								<div slot="label" v-html='"補假日期&nbsp;&nbsp;"'
									style="display: inline-block;color: #000000;"></div>
								<div style="position: relative;left: .5rem;display: inline-block;">
									<a-input placeholder='請輸入' v-model="form.bjdate1" class='warp_width'
										@blur="yearfn('bjdate1')" style=' width: 5.5rem;' :maxLength='4' />
									<div style="display: inline-block;margin: 0 .8rem;">年</div>
									<a-input placeholder='請輸入' v-model="form.bjdate2" class='warp_width'
										@blur="yearfn('bjdate2','y')" style=' width: 5.5rem;' :maxLength='2' />
									<div style="display: inline-block;margin: 0 .8rem;">月</div>
									<a-input placeholder='請輸入' v-model="form.bjdate3" class='warp_width'
										@blur="yearfn('bjdate3','d')" style=' width: 5.5rem;' :maxLength='2' />
									<div style="display: inline-block;margin-left: .8rem;">日</div>
								</div>
							</a-form-model-item>
						</div>
						<div>
							<a-form-model-item>
								<div slot="label" v-html='"補假時間&nbsp;&nbsp;"'
									style="display: inline-block;color: #000000;"></div>
								<div style="position: relative;left: .5rem;display: inline-block;">
									<a-input placeholder='請輸入' v-model="form.bjbegintime1" class='warp_widths'
										:maxLength='2' @blur="inputnum('bjbegintime1','s')" />
									<div style="display: inline-block;margin: .2rem;">:</div>
									<a-input placeholder='請輸入' v-model="form.bjbegintime2" class='warp_widths'
										:maxLength='2' @blur="inputnum('bjbegintime2')" />
									<div style="display: inline-block;margin: 0 .6rem;">-</div>
									<a-input placeholder='請輸入' v-model="form.bjendtime1" class='warp_widths'
										:maxLength='2' @blur="inputnum('bjendtime1','s')" />
									<div style="display: inline-block;margin: .2rem;">:</div>
									<a-input placeholder='請輸入' v-model="form.bjendtime2" class='warp_widths'
										:maxLength='2' @blur="inputnum('bjendtime2')" />
								</div>
							</a-form-model-item>
						</div>

						<div>
							<a-form-model-item>
								<div slot="label" v-html='"補假時數&nbsp;&nbsp;"'
									style="display: inline-block;color: #000000;"></div>
								<div style="position: relative;left: .5rem;display: inline-block;">{{form.str2}}
								<!-- {{backdate()}} -->
								</div>
							</a-form-model-item>
						</div>
					</a-form-model>
					<div style="text-align: center;padding-bottom: 1.2rem ;">
						<button class='btn1 btnx' @click='resetForm("1")'>
							<!-- 下單 -->
							儲存
						</button>
						<button class='btn1 btn2' @click='resetForm("2")'>提交</button>
					</div>
				</div>
				<div>

					<!-- <rl></rl> -->
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import rl from './rlmate.vue'
	import App from '@/assets/app.js';

	export default {
		props: ['applyid', 'pared'],
		components: {
			rl
		},
		data() {
			return {
				fourthqty: '',
				formview: {
					createtime: "23/06/2021",
					department: "行政",
					position: "前台客服",
					realname: "song",
					job: '',
					sex: 0,
				},
				visible: true,
				ishand: false,
				rules: {},
				form: {
					"type": 3, //類型 1 假期申請 2 外出 3加班
					"jbtype": 1, // 1 加班費 2 補假
					"jbdate": "2021-6-4", //加班日期
					"begintime:": "9:00", //加班開始
					begintime1: '',
					begintime2: '',
					"endtime": "18:00", //加班截止
					endtime1: '',
					endtime2: '',
					"bjdate": "2021-6-3", // 補假日期
					bjdate1: '',
					bjdate2: '',
					bjdate3: '',
					"bjbegintime": "9:00", //補假開始
					bjbegintime1: '',
					bjbegintime2: '',
					"bjendtime": "18:00", //補假截止
					bjendtime1: '',
					bjendtime2: '',
					issave: '', //issave 提交 2 儲存 1
					num1: [],
					num2: []
				},
				yeararr: [{
					text: '加班費',
					value: '1',
				}, {
					text: '補假',
					value: '2',
				}],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
				],
			}
		},
		watch: {
			
		},
		created(){
			let _this = this;
			_this.handimg()
		},
		mounted() {
			
		},
		methods: {
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || '',
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						if (this.pared.applyid) {
							let arr = {}
							arr = res.data
							arr.endtime1 = ''
							arr.endtime2 = ''
							arr.begintime1 = ''
							arr.begintime2 = ''
							arr.bjdate1 = ''
							arr.bjdate2 = ''
							arr.bjdate3 = ''
							arr.bjbegintime1 = ''
							arr.bjbegintime2 = ''
							arr.bjendtime1 = ''
							arr.bjendtime2 = ''
							// arr.jbdate = arr.jbdate.split('-')[2]+'-'+arr.jbdate.split('-')[1]+'-'+arr.jbdate.split('-')[0]
							if (arr.endtime) {
								arr.endtime1 = arr.endtime.split(':')[0]
								arr.endtime2 = arr.endtime.split(':')[1]
							}

							if (arr.begintime) {
								arr.begintime1 = arr.begintime.split(':')[0]
								arr.begintime2 = arr.begintime.split(':')[1]
							}
							if (arr.bjdate) {
								arr.bjdate1 = arr.bjdate.split('-')[0]
								arr.bjdate2 = arr.bjdate.split('-')[1]
								arr.bjdate3 = arr.bjdate.split('-')[2]
							}
							if (arr.bjbegintime) {
								arr.bjbegintime1 = arr.bjbegintime.split(':')[0]
								arr.bjbegintime2 = arr.bjbegintime.split(':')[1]
							}
							if (arr.bjendtime) {
								arr.bjendtime1 = arr.bjendtime.split(':')[0]
								arr.bjendtime2 = arr.bjendtime.split(':')[1]
							}
							arr.num1 = []
							arr.num2 = []
							this.form = {}
							this.form = arr
							this.backdate()
							// if(this.form.jbtype == 2){ 

							// }
						}
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			backdate() {
				let num1, num2, b1, b2;
				num1 = (this.form.endtime1 * 1 >= this.form.begintime1 * 1) ? (this.form.endtime1 * 1 - this.form
					.begintime1 * 1) : ((this.form.endtime2 * 1 + 24) - this.form.begintime2 * 1)
				num2 = (this.form.endtime2 * 1 >= this.form.begintime2 * 1) ? (this.form.endtime2 * 1 - this.form
					.begintime2 * 1) : ((this.form.endtime2 * 1 + 60) - this.form.begintime2 * 1)
				b1 = (this.form.bjendtime1 * 1 >= this.form.bjbegintime1 * 1) ? (this.form.bjendtime1 * 1 - this.form
					.bjbegintime1 * 1) : (this.form.bjendtime1 * 1 - this.form.bjbegintime1 * 1 + 24)
				b2 = (this.form.bjendtime2 * 1 >= this.form.bjbegintime2 * 1) ? (this.form.bjendtime2 * 1 - this.form
					.bjbegintime2 * 1) : (this.form.bjendtime2 * 1 - this.form.bjbegintime2 * 1 + 60)
				if ((num1 >= 0 && num2 > 0) || (num1 > 0 && num2 >= 0)) {
					this.form.num1 = [num1, num2]
					this.$set(this.form,'str1', num1 + '時' + num2 + '分')
					// this.form.str1 = num1 + '時' + num2 + '分'
				}
				if ((b1 >= 0 && b2 > 0) || (b1 > 0 && b2 >= 0)) {
					this.form.num2 = [b1, b2]
					this.$set(this.form,'str2', b1 + '時' + b2 + '分')
					// this.form.str2 = b1 + '時' + b2 + '分'
				}
			},
			handff(val) {
				this.form.jbdate = ''
				if (val) {
					this.form.jbdate = val
				}
			},
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' +
					(time
						.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			yearfn(val, sta) {
				 if (isNaN(Number(this.form[val]))) {
					this.form[val] = ''
				} else {
					if (this.form[val] == '') {
						return
					}
					this.form[val] = (Number(this.form[val])).toFixed(0)
					if (sta == 'y') {
						if (this.form[val] > 12) {
							this.form[val] = ''
						}
					}
					if (sta == 'd') {
						if (this.form[val] > 31) {
							this.form[val] = ''
						}
					}
					if (0 <= this.form[val] && this.form[val] < 10) {
						this.form[val] = '0' + this.form[val]
					}
				}
				
			},
			inputnum(val, sta) {
				if (isNaN(Number(this.form[val]))) {
					this.form[val] = ''
				} else {
					if (this.form[val] == '') {
						return
					}
					this.form[val] = (Number(this.form[val])).toFixed(0)
					if (0 <= this.form[val] && this.form[val] < 10) {
						this.form[val] = '0' + this.form[val]
					}
					if (sta == 's') {
						if (this.form[val] > 24) {
							this.form[val] = ''
						}
					} else {
						if (this.form[val] > 60) {
							this.form[val] = ''
						}
					}
				}
					 this.backdate()
			},
			resetForm(val) {
				if (!this.form.jbdate) {
					App.oTool.warningT('請選擇加班費日期');
					return
				}
				if (!this.form.jbtype) {
					App.oTool.warningT('請選擇加班費還是補假');
					return
				}
				// if(this.form.jbtype == 1){//加班費
				if (this.form.begintime1 && this.form.begintime2 && this.form.endtime1 && this.form.endtime2) {
					this.form.begintime = this.form.begintime1 + ':' + this.form.begintime2
					this.form.endtime = this.form.endtime1 + ':' + this.form.endtime2
				} else {
					App.oTool.warningT('請填寫具體加班時間');
					return
				}
				// }
				if (this.form.jbtype == 2) { //補假
					if (this.form.bjdate1 && this.form.bjdate2 && this.form.bjdate3 &&
						this.form.bjbegintime1 && this.form.bjbegintime2 && this.form.bjendtime1 && this.form.bjendtime2) {
						this.form.bjdate = this.form.bjdate1 + '-' + this.form.bjdate2 + '-' + this.form.bjdate3
						this.form.bjbegintime = this.form.bjbegintime1 + ':' + this.form.bjbegintime2
						this.form.bjendtime = this.form.bjendtime1 + ':' + this.form.bjendtime2
					} else {
						App.oTool.warningT('請填寫具體補假時間');
						return
					}
// bjdate jbdate			
					//補假時間  能小于等于加班时间
					if (this.form.num1.length>0 && this.form.num2.length>0) {
						if ((this.form.num1[0] < this.form.num2[0]) || (this.form.num1[1] < this.form.num2[1])) {
							App.oTool.warningT('補假時間小于等于加班时间');
							return
						}
					}
				}
				this.form.issave = val
				this.form.token = this.$store.state.token;
				this.form.asktype = "1"
				this.form.type = 3
				// this.$refs[formName].resetFields();
				this.$ajax({
					method: 'post',
					url: this.$api.newApply,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#handitemjiaban {
		.warp_widths {
			width: 5rem;
		}

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 7rem;
		}

		.titName {
			font-size: .8rem !important;
			color: #000;
			height: 2rem;
		}

		.comname {
			font-size: .8rem !important;
		}

		.ant-modal {
			top: 6vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: .8rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .6rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
			width: 4rem;
		}

		.ant-input {
			font-size: .8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
